import { render, staticRenderFns } from "./materialTable.vue?vue&type=template&id=04f03d06&scoped=true"
import script from "./materialTable.vue?vue&type=script&lang=js"
export * from "./materialTable.vue?vue&type=script&lang=js"
import style0 from "./materialTable.vue?vue&type=style&index=0&id=04f03d06&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f03d06",
  null
  
)

export default component.exports